import React, { useState, useEffect, FunctionComponent, Fragment, useRef } from "react"
import { IconContext } from "react-icons/lib"
import { TbUserScan } from "react-icons/tb"
import { IoMdMore } from "react-icons/io"
import { FaRegEdit } from "react-icons/fa"
import { HiOutlineTrash } from "react-icons/hi"
import useDetectOutsideClick from "@murphy-frontend/web-core/hooks/useDetectOutsideClick"
import { useModal } from "@murphy-frontend/web-core/contexts/ModalContext"
import { ModalConfiguration } from "@murphy-frontend/web-core/components/Modal"


interface ActionsRowProps {
	templateId: number
	onEditTemplate: (id: number) => void
	onDeleteTemplate: (id: number) => void
	translations: Record<string, string>
}

const ActionsRow: FunctionComponent<ActionsRowProps> = ({
	templateId,
	onEditTemplate,
	onDeleteTemplate,
	translations
}) => {
	const dropdownRef = useRef(null)
	const [dropDownVisible, toggleDropDown] = useDetectOutsideClick(dropdownRef, false)
	const { openModal, closeModal } = useModal()

	const onClickToggleDropdown = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		event.stopPropagation()
		toggleDropDown(!dropDownVisible)
	}

	

	const dropDownClasses = dropDownVisible
		? "useradmin-dropdown-content icon-hover-child useradmin-dropdown-content--active"
		: "useradmin-icon-hover useradmin-dropdown-content"

	return (
		<>
			<div className='useradmin-more-wrapper' onClick={onClickToggleDropdown} ref={dropdownRef}>
				<IconContext.Provider value={{ className: "btn-icon actions-more" }}>
					<IoMdMore />
				</IconContext.Provider>
				<div className={dropDownClasses}>
					<div className='useradmin-select' onClick={() => onEditTemplate(templateId)}>
						<IconContext.Provider value={{ className: "btn-icon useradmin-more" }}>
							<FaRegEdit />
						</IconContext.Provider>
						{translations.choosetemplate}
					</div>
					<div className='useradmin-select' onClick={() => onDeleteTemplate(templateId)}>
						<IconContext.Provider value={{ className: "btn-icon useradmin-more" }}>
							<HiOutlineTrash />
						</IconContext.Provider>
						{translations.deletetemplate}
					</div>				
				</div>
			</div>
		</>
	)
}

export default ActionsRow
